var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.textAlign},[_vm._t("ctitle")],2),_c('div',{class:_vm.textAlign},[_vm._t("ctext")],2),_c('div',{class:['c-action', _vm.textAlign]},[_vm._t("caction",[_vm._v("leer más")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }